export default __webpack_public_path__ + "static/georg-dieners-266x266-ff34382a5a39ed36a25ed0f15b13286d.jpg";